import Table from './table.vue'
 
const table = {
 install(Vue) {
   //注册全局组件
   Vue.component('Table', Table)
 }
}
export default table;
